import React from 'react';

interface StatusBadgeProps {
  status: 'active' | 'inactive' | 'archived';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const classes = status === 'active'
    ? 'bg-green-100 text-green-800'
    : status === 'archived'
    ? 'bg-gray-100 text-gray-800'
    : 'bg-red-100 text-red-800';

  return (
    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${classes}`}>
      {status}
    </span>
  );
};

export default StatusBadge;
